import { useId } from 'react';

export function SubtleEngineeringBg() {
  const id = useId().replace(/:/g, '');
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden -z-10">
      {/* Blueprint-style grid pattern */}
      <div className="absolute inset-0 opacity-[0.025]">
        <div className="h-full w-full" style={{
          backgroundImage: `
            linear-gradient(0deg, transparent 24%, rgba(249, 115, 22, 0.2) 25%, rgba(249, 115, 22, 0.2) 26%, transparent 27%, transparent 74%, rgba(249, 115, 22, 0.2) 75%, rgba(249, 115, 22, 0.2) 76%, transparent 77%, transparent),
            linear-gradient(90deg, transparent 24%, rgba(249, 115, 22, 0.2) 25%, rgba(249, 115, 22, 0.2) 26%, transparent 27%, transparent 74%, rgba(249, 115, 22, 0.2) 75%, rgba(249, 115, 22, 0.2) 76%, transparent 77%, transparent)
          `,
          backgroundSize: '80px 80px',
        }} />
      </div>

      {/* Subtle corner gradients */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] opacity-[0.04]">
        <div className="absolute inset-0 bg-gradient-to-br from-orange-400 via-orange-300 to-transparent rounded-full blur-[100px]" />
      </div>

      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] opacity-[0.04]">
        <div className="absolute inset-0 bg-gradient-to-tr from-orange-400 via-orange-300 to-transparent rounded-full blur-[100px]" />
      </div>

      {/* Diagonal line accent */}
      <svg className="absolute top-0 right-0 w-full h-full opacity-[0.03]" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id={`diagonal-lines-${id}`} x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            <line x1="0" y1="0" x2="40" y2="40" stroke="rgba(249, 115, 22, 0.4)" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#diagonal-lines-${id})`} />
      </svg>
    </div>
  );
}
